import React from "react";
import PanelListD from "./PanelListDesktop";
import PlaysList from "./PlaysListMobile";
import { useMediaQuery } from 'react-responsive'


export default function PlaysListResponsive(){
    const isMobileDevice = useMediaQuery({
        query: "(max-width: 48em)",
      });

  return(
      <div>
        {!isMobileDevice && <PanelListD/>}
        {isMobileDevice && <PanelListD/>}  
      </div>
    )
}

